// src/components/SongListItem.jsx
import React, { useState } from 'react';
import './SongListItem.css';

const SongListItem = ({ title, author, duration, colorStart, colorEnd, onMakeSimilar }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLiked, setIsLiked] = useState(false);

  const handlePlayToggle = (e) => {
    e.stopPropagation();
    setIsPlaying(!isPlaying);
  };

  const handleLikeToggle = (e) => {
    e.stopPropagation();
    setIsLiked(!isLiked);
  };

  return (
    <div className="song-list-item">
      {/* 左侧封面 */}
      <div 
        className="song-cover"
        style={{ background: `linear-gradient(135deg, ${colorStart}, ${colorEnd})` }}
        onClick={handlePlayToggle}
      >
        <div className={`play-overlay ${isPlaying ? 'playing' : ''}`}>
          <i className={`fas ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
        </div>
      </div>

      {/* 中间信息 */}
      <div className="song-info">
        <h4 className="song-title">{title}</h4>
        <div className="song-meta">
          <span className="song-author">{author}</span>
          <span className="song-duration"><i className="far fa-clock"></i> {duration}</span>
        </div>
      </div>

      {/* 右侧操作区 */}
      <div className="song-actions">
        {/* 动态播放指针/均衡器 */}
        <div className={`play-pointer ${isPlaying ? 'active' : ''}`}>
            <span></span><span></span><span></span>
        </div>

        {/* 收藏按钮 */}
        <button 
          className={`action-btn like-btn ${isLiked ? 'liked' : ''}`} 
          onClick={handleLikeToggle}
        >
          <i className={`fas fa-heart`}></i>
        </button>

        {/* 做同款按钮 */}
        <button className="action-btn make-btn" onClick={onMakeSimilar}>
          <span>做同款</span>
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default SongListItem;